define('ua/dimension-extractors',[
    'domhelpers',
    'adlhelpers'
], function(domHelpers, ADL) {
    'use strict';

    function Extractors() {
        /**
         *  Extracts the contents of the UA Entry Info cookie into an object
         *
         *  @example
         *    extractors.parseEntryInfoCookie(ua);
         *
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {Object} - Object of cookie data based on the uaConfig.entryInfoCookieFormat
         */
        this.parseEntryInfoCookie = function(ua) {
            var uaConfig = ua.getConfig(),
                cookieData = domHelpers.getCookie(uaConfig.entryInfoCookie),
                cookieFormat = uaConfig.entryInfoCookieFormat,
                retData = {},
                win = domHelpers.getWindow(),
                splitData,
                tmpVal,
                i,
                len;

            if (cookieData === null) {
                splitData = [];
            } else {
                splitData = cookieData.split(':');
            }

            for (i = 0, len = cookieFormat.length; i < len; i++) {
                tmpVal = splitData[i];

                if (tmpVal === undefined) {
                    tmpVal = '-1';
                }

                retData[cookieFormat[i]] = win.decodeURIComponent(tmpVal);
            }

            return retData;
        };


        /**
         *  Updates the UA Entry Info cookie. Has a hard coded 30 minutes (session) timeout
         *
         *  @example
         *    extractors.updateValueEntryInfoCookie(ua, {entrypagename: 'testpage'}, 'homeaway.com');
         *
         *  @param {Object} [ua] - UA-wrapper object
         *  @param {Object} [data] - Cookie data object to set based on updateValueEntryInfoCookie
         *  @param {Stirng} [hostname] - Hostname of cookie
         */
        this.updateValueEntryInfoCookie = function(ua, data, hostname) {
            var uaConfig = ua.getConfig(),
                cookieData = this.parseEntryInfoCookie(ua),
                cookieFormat = uaConfig.entryInfoCookieFormat,
                win = domHelpers.getWindow(),
                cookieArr = [],
                tmpVal,
                i,
                len;

            for (i = 0, len = cookieFormat.length; i < len; i++) {
                tmpVal = data[cookieFormat[i]];

                if (data[cookieFormat[i]] !== undefined) {
                    tmpVal = data[cookieFormat[i]];
                } else if (cookieData[cookieFormat[i]]) {
                    tmpVal = cookieData[cookieFormat[i]];
                }

                if (tmpVal === undefined) {
                    tmpVal = '-1';
                }

                cookieArr.push(win.encodeURIComponent(tmpVal));
            }

            domHelpers.setCookie(uaConfig.entryInfoCookie, cookieArr.join(':'), hostname, 30);
        };


        /**
         *  Extractor for the UA visitorid/clientid
         *
         *  @example
         *    var cid = extractors.getVisitorId(new ADL({}), ua, tracker);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @param {Object} [tracker] - UA Tracker
         *  @returns {String} - first segmenet of the UA clientid
         */
        this.getVisitorId = function(adl, ua, tracker) {
            var cid = tracker.get('clientId'),
                retval;

            if (cid) {
                retval = cid;
            } else {
                ua.uaEdap.error('could not get UA clientid, skipping...');
                retval = '-1';
            }

            return retval;
        };


        /**
         *  Extractor for the Entry Page Name
         *
         *  @example
         *    var ep = extractors.getEntryPageName(new ADL({}), ua, tracker);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {String} - the entry page name
         */
        this.getEntryPageName = function(adl, ua) {
            var cookieData = this.parseEntryInfoCookie(ua),
                profileData = ua.getUAProfileData(),
                profileCookieDomain = profileData[1],
                ep;

            ep = cookieData.entrypagename;

            if (ep === '-1') {
                ep = adl.get('pagename');
                this.updateValueEntryInfoCookie(ua, {entrypagename: ep}, profileCookieDomain);
            } else {
                this.updateValueEntryInfoCookie(ua, {entrypagename: ep}, profileCookieDomain);
            }

            return ep;
        };


        /**
         *  Extractor for the Entry Page Type
         *
         *  @example
         *    var ept = extractors.getEntryPageType(new ADL({}), ua);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {String} - the entry page type
         */
        this.getEntryPageType = function(adl, ua) {
            var cookieData = this.parseEntryInfoCookie(ua),
                profileData = ua.getUAProfileData(),
                profileCookieDomain = profileData[1],
                ept;

            ept = cookieData.entrypagetype;

            if (ept === '-1') {
                ept = adl.get('pagetype');
                this.updateValueEntryInfoCookie(ua, {entrypagetype: ept}, profileCookieDomain);
            } else {
                this.updateValueEntryInfoCookie(ua, {entrypagetype: ept}, profileCookieDomain);
            }

            return ept;
        };


        /**
         *  Extractor for Brand
         *
         *  @example
         *    var brand = extractors.getBrand(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - the brand
         */
        this.getBrand = function(adl) {
            if (adl.isSet('monikerbrand')) {
                return adl.get('monikerbrand');
            } else if (adl.isSet('brand')) {
                return adl.get('brand');
            }

            return '-1';
        };


        /**
         *  Extractor for the url
         *
         *  @example
         *    var href = extractors.getUrl(new ADL({}), ua);
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @returns {String} - the url
         */
        this.getUrl = function(adl, ua) {
            var href = '-1';

            try {
                href = domHelpers.getPage();
            } catch (err) {
                ua.uaEdap.error('Error when extracting UA url: ' + err.message);
            } finally {
                return href;
            }
        };


        /**
         *  Extractor for the Search Term
         *
         *  @example
         *    var searchterm = extractors.getSearchTerm(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - Search term based on the ADL
         */
        this.getSearchTerm = function(adl) {
            if (adl.isSet('searchterm')) {
                return adl.get('searchterm');

            // TECHDEBT: GT sets ADl.keywords right now, should be removed when they set ADL.searchterm correctly
            } else if (adl.isSet('keywords')) {
                return adl.get('keywords');
            }

            return '-1';
        };


        /**
         *  Extractor for the "CalendarLastUpdated" value
         *
         *  @example
         *    var calendarlastupdated = extractors.getCalendarLastUpdated(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - "CalendarLastUpdated" value based on the ADL
         */
        this.getCalendarLastUpdated = function(adl) {
            if (adl.isSet('calendarlastupdated')) {
                return adl.get('calendarlastupdated');

            // TECHDEBT: GT sets ADl.calendarupdated right now, should be removed when they set ADL.calendarlastupdated correctly
            } else if (adl.isSet('calendarupdated')) {
                return adl.get('calendarupdated');
            }

            return '-1';
        };


        /**
         *  Extractor for the "getPDPEntryDate" value
         *
         *  @example
         *    var pdpentrydate = extractors.getPDPEntryDate(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - "getPDPEntryDate" value based on the ADL
         */
        this.getPDPEntryDate = function(adl) {
            var startDate,
                endDate;

            if (adl.get('pagetype') === 'property') {
                startDate = adl.get('startdate');
                endDate = adl.get('enddate');

                return ((typeof startDate === 'string' && startDate.length > 0) &&
                        (typeof endDate === 'string' && endDate.length > 0)) ? 'dates on PDP' : 'no dates';
            }

            return '-1';
        };


        /**
         *  Extractor for proctor logging
         *
         *  @example
         *    var proctorDataStruct = extractors.getProctorDimension(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {Array} - [{String} dimensionId, {String} proctorTestString]
         */
        this.getProctorDimension = function(adl) { // eslint-disable-line complexity
            // disabled eslint complexity rather than refactoring since sharding out proctor data is TECHDEBT
            var proctor = adl.get('proctor'),
                pageAdl = new ADL(),
                retData;

            if (proctor === undefined || proctor === null || proctor === '') {
                proctor = '-1';
            }

            // TECHDEBT: get pagetype from the page's ADL rather than the event data because of the overridden pagetype on quote event VPVs
            switch (pageAdl.get('pagetype')) {
                case 'booking':
                case 'booking payment':
                    retData = ['48', proctor];
                    break;

                case 'cart':
                    retData = ['30', proctor];
                    break;

                case 'travelerdash':
                    retData = ['96', proctor];
                    break;

                case 'home':
                    retData = ['99', proctor];
                    break;

                case 'ownerdash':
                    if (adl.get('appname') === 'global-dashboard-ui') {
                        retData = ['44', proctor];
                    } else {
                        retData = ['28', proctor];
                    }
                    break;

                case 'search landing page':
                    if (adl.get('appname') === 'landingpageapp') {
                        retData = ['102', proctor];
                    } else {
                        // NOTE: node-slp will be getting on proctor at some point, don't want them clobbering landingpageapp
                        retData = ['-1', '-1'];
                    }
                    break;

                default:
                    retData = ['38', proctor];
            }

            return retData;
        };


        /**
         *  Extractor for ppc ids
         *
         *  @example
         *    var ppc = extractors.getPPC(new ADL({}), ua, tracker);
         *
         *  @returns {String} - PPC ID
         */
        this.getPPC = function() {
            var val = domHelpers.getSearchParam('k_clickid');

            return val || '-1';
        };


        /**
         *  Extractor for ICID vals
         *
         *  @example
         *    var icid = extractors.getICID(new ADL({}), ua, tracker);
         *
         *  @returns {String} - ICIC value
         */
        this.getICID = function() {
            var val = domHelpers.getSearchParam('icid');

            return val || '-1';
        };


        /**
         *  Gets a normalized ADL.propertydetails string.
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - Normalized ADL.propertydetails string based on the latest ADL Spec
         */
        this.getPropertyDetailsString = function(adl) {
            // TECHDEBT: Remove this when GT, VRBO and TC are all using ',' as their delimeters
            if (adl.get('propertydetails')) {
                return adl.get('propertydetails').replace(/:/g, ',');
            }
            return '-1';
        };


        /**
         *  Gets the value at a certain index position in ADL.propertydetails
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Number} [index] - Index position to return the value
         *  @returns {String} - Value, or '-1', at the index position in ADL.propertydetails
         */
        this.getPropertyDetailsIndex = function(adl, index) {
            var pdString = this.getPropertyDetailsString(adl),
                pdParts = pdString.split(/,/);

            if (pdParts[index] !== undefined) {
                return pdParts[index];
            }

            return '-1';
        };


        /**
         *  Gets the value either in the ADL or from a certain index position in ADL.propertydetails.
         *
         *  @example
         *    var pdData = extractors.getPropertyDetail(new ADL({}), 18, 'multiunit');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Number} [index] - Index position of data in ADL.propertydetails
         *  @param {String} [adlName] - ADL property name
         *  @returns {String} - ADL[adlName] or ADL.propertydetails at "index" position, or "-1"
         */
        this.getPropertyDetail = function(adl, pdIndex, adlName) {
            var pdString = this.getPropertyDetailsString(adl),
                retval;

            if (adl.get(adlName) !== undefined) {
                retval = adl.get(adlName);
            } else if (pdString !== '-1') {
                retval = this.getPropertyDetailsIndex(adl, pdIndex);
            } else {
                retval = '-1';
            }

            return retval;
        };


        /**
         *  Gets the "onlinepayments" data from the ADL or ADL.propertydetails
         *
         *  @example
         *    var pdData = extractors.getHasOnlinePayments(new ADL({}), 12, 'onlinepayments');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Number} [index] - Index position of data in ADL.propertydetails
         *  @param {String} [adlName] - ADL property name
         *  @returns {String} - ADL[adName] or 'true'/'false' based on value of ADL.propertydetails at "index", or "-1"
         */
        this.getHasOnlinePayments = function(adl, pdIndex, adlName) {
            var pdString = this.getPropertyDetailsString(adl),
                pdData;

            if (adl.get(adlName) !== undefined) {
                return adl.get(adlName);
            } else if (pdString !== '-1') {
                pdData = this.getPropertyDetailsIndex(adl, pdIndex);

                // TECHDEBT: Remove old ADL.propertydetails value mappings
                if (pdData === 'ry') {
                    return 'true';
                } else if (pdData === 'rn') {
                    return 'false';
                }
            }

            return '-1';
        };


        /**
         *  Gets the "translated" data from the ADL or ADL.propertydetails
         *
         *  @example
         *    var pdData = extractors.getIsTranslated(new ADL({}), 11, 'translated');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Number} [index] - Index position of data in ADL.propertydetails
         *  @param {String} [adlName] - ADL property name
         *  @returns {String} - ADL[adName] or 'true'/'false' based on value of ADL.propertydetails at "index", or "-1"
         */
        this.getIsTranslated = function(adl, pdIndex, adlName) {
            var pdString = this.getPropertyDetailsString(adl),
                pdData;

            if (adl.get(adlName) !== undefined) {
                return adl.get(adlName);
            } else if (pdString !== '-1') {
                pdData = this.getPropertyDetailsIndex(adl, pdIndex);

                // TECHDEBT: Remove old ADL.propertydetails value mappings
                if (pdData === 'transy') {
                    return 'true';
                } else if (pdData === 'transn') {
                    return 'false';
                }
            }

            return '-1';
        };


        /**
         *  Gets the "Number of Reviews" data from the ADL or ADL.propertydetails
         *
         *  @example
         *    var pdData = extractors.getNumberOfReviews(new ADL({}), 15, 'numreviews');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Number} [index] - Index position of data in ADL.propertydetails
         *  @param {String} [adlName] - ADL property name
         *  @returns {String} - ADL[adName] or number of reviews based on value of ADL.propertydetails at "index", or "-1"
         */
        this.getNumberOfReviews = function(adl, pdIndex, adlName) {
            var pdString = this.getPropertyDetailsString(adl),
                pdData,
                regexData;

            if (adl.get(adlName) !== undefined) {
                return adl.get(adlName);
            } else if (pdString !== '-1') {
                pdData = this.getPropertyDetailsIndex(adl, pdIndex);

                // TECHDEBT: Remove old ADL.propertydetails value mappings
                regexData = pdData.match(/^rev(\d+)/);

                if (regexData !== null) {
                    return regexData[1];
                }
            }

            return '-1';
        };


        /**
         *  Gets the "multiunit" data from the ADL or ADL.propertydetails
         *
         *  @example
         *    var pdData = extractors.getMultiUnit(new ADL({}), 13, 'multiunit');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Number} [index] - Index position of data in ADL.propertydetails
         *  @param {String} [adlName] - ADL property name
         *  @returns {String} - ADL[adName] or 'true'/'false' based on value of ADL.propertydetails at "index", or "-1"
         */
        this.getMultiUnit = function(adl, pdIndex, adlName) {
            var pdString = this.getPropertyDetailsString(adl),
                pdData;

            if (adl.get(adlName) !== undefined) {
                return adl.get(adlName);
            } else if (pdString !== '-1') {
                pdData = this.getPropertyDetailsIndex(adl, pdIndex);

                // TECHDEBT: Remove old ADL.propertydetails value mappings
                if (pdData === 'multiy') {
                    return 'true';
                } else if (pdData === 'multin') {
                    return 'false';
                }
            }

            return '-1';
        };


        /**
         *  Extractor for the EDAP-Integrations Version
         *
         *  @example
         *    var eiVersion = extractors.getEDAPIntegrationsVersion(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - the EDAP-Integrations version or 'unknown'
         */
        this.getEDAPIntegrationsVersion = function(adl) {
            var version = domHelpers.getEdapIntegrationsVersion();

            if (adl.shouldSet(version)) {
                return version;
            }

            return 'unknown';
        };


        /**
         *  Extractor for the Trip Dates
         *
         *  @example
         *    var tripDates = extractors.getTripDates(new ADL({}));
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @returns {String} - the Trip Dates string in the format "ADL.eventstartdate,ADL.eventenddate"
         *                      or "ADL.startdate,ADL.enddate". If both values are missing, a "-1" is returned
         */
        this.getTripDates = function(adl) {
            var startDate = 'startdate',
                endDate = 'enddate',
                eventStartDate = 'event' + startDate,
                eventEndDate = 'event' + endDate,
                datesStr = '-1',
                dates;

            if (adl.isSet(eventStartDate) && adl.isSet(eventEndDate)) {
                dates = [
                    adl.get(eventStartDate),
                    adl.get(eventEndDate)
                ];
            } else if (adl.isSet(startDate) && adl.isSet(endDate)) {
                dates = [
                    adl.get(startDate),
                    adl.get(endDate)
                ];
            }

            if (dates) {
                datesStr = dates.join(',');
            }

            return datesStr;
        };


        /**
         *  Abstract extractor that will return a value in the form:
         *      "ADL.minKey,ADL.maxKey"
         *   where missing values are set as a "-1" and if both values are missing then
         *   it returns a "-1"
         *
         *  @example
         *    var searchGuests = extractors.getRangeSet(new ADL({}), ua, 'minsleeps', 'maxsleeps');
         *
         *  @param {Object} [adl] - ADLHelper instance
         *  @param {Object} [ua] - UA-wrapper object
         *  @param {String} [minKey] - Minimum (left side) ADL key to lookup
         *  @param {String} [maxKey] - Maximum (right side) ADL key to lookup
         *  @returns {String} - comma-delimited list of "ADL.minKey,ADL.maxKey"
         *                      Missing values are set as a "-1", if both values are missing then this
         *                      will return "-1";
         */
        this.getRangeSet = function(adl, ua, minKey, maxKey) {
            var defaultValue = '-1',
                minVal,
                maxVal;

            if (!minKey || !maxKey) {
                ua.uaEdap.error('getRangeSet: Incorrect min/maxKey parameters: minKey:"' + minKey + '" maxKey:"' + maxKey + '"');
                return defaultValue;
            }

            // If either is set then we need to return a value
            if (adl.isSet(minKey) || adl.isSet(maxKey)) {
                minVal = (adl.isSetGet(minKey) === undefined ? defaultValue : adl.get(minKey));
                maxVal = (adl.isSetGet(maxKey) === undefined ? defaultValue : adl.get(maxKey));
                return minVal + ',' + maxVal;
            }

            return defaultValue;
        };


        /**
         * Splits a string "list" from the ADL into "pages", ensuring that a single element isn't split across pages, and returns the requested `page`
         *
         * Page size is the maximum number of bytes allowed in a Custom Dimension (specified in ua-config.js)
         *
         * Algorithm:
         *    1. start with the (150*page)th character and work back until we find a delimiter
         *    2. take the next 150 characters but work backward to the last delimiter to exclude partial elements
         *    3. return the substring between those indices
         *
         * NOTE: This function is *NOT* UTF-8 safe
         *
         * @param  {Object} adl   ADLHelper instance
         * @param  {Object} ua    UA-wrapper object
         * @param  {String} field Name of the ADL field to paginate
         * @param  {Number} page  What "page" of the string to return
         * @return {String}       The requested `page` from `adl.get(field)`
         */
        this.getPageFromPaginatedAdlList = function(adl, ua, field, page) {
            var defaultValue = '-1',
                delimiter = ',',
                uaConfig = ua.getConfig(),
                maxDimensionBytes = uaConfig.maxDimensionBytes,
                listStr = adl.get(field),
                startIndex,
                endIndex;

            if (!listStr) {
                return defaultValue;
            }

            startIndex = maxDimensionBytes * page;

            // walk back to the most recent delimiter, then add 1 to get to the start of the next grouping
            if (startIndex !== 0 && startIndex < listStr.length) {
                while (listStr.charAt(startIndex) !== delimiter) {
                    startIndex--;
                }

                startIndex++;
            }

            // now startIndex is set, let's figure out where to stop
            endIndex = startIndex + maxDimensionBytes;

            // Just like we did with startIndex, walk back until we find the delimiter
            // If we find a final delimiter, leave endIndex pointing at it so that it isn't included by substring() below
            if (endIndex < listStr.length) {
                while (listStr.charAt(endIndex) !== delimiter) {
                    endIndex--;
                }
            }

            return listStr.substring(startIndex, endIndex);
        };


        /**
         * Gets the HomeAway visitor ID from the 'hav' cookie
         *
         * @return {String} The HA Visitor ID
         */
        this.getHaVisitorID = function() {
            return domHelpers.getCookie('hav') || '-1';
        };

        /**
         * Gets the HomeAway session ID from the 'has' cookie
         *
         * @return {String} The HA session ID
         */
        this.getHaSessionID = function() {
            return domHelpers.getCookie('has') || '-1';
        };
    }

    return new Extractors();
});

